export default __webpack_public_path__ + "static/media/features_img.5deab25d.png";